import {
    CUSTOMERS_PRICE_LOG_PATH,
    PRICE_BONDS_PATH,
    PRICE_BONDS_LAST_DATE_PATH,
    PRICE_LAST_DATE_PATH,
    PRICE_PATH,
    PRICE_V2_PATH,
    PRICE_PU_PATH,
    PRICE_TABLE_LAST_DATE_PATH,
    PRICE_TABLE_PRICE_VARIANTION_PATH,
    PRICE_UPDATE_SPREADS_PATH
} from "src/utils/api-routes"
import {DATE_FORMAT, DATE_FORMAT_SHOW} from "src/utils/constants"
import {ExportFile} from "src/utils/export-file"
import {formatDate} from "src/utils/format-date"
import {formatDecimalCaseReplaceComma, formatStringToFloatDecimalCase} from "src/utils/format-decimal"
import {ServiceRequest} from "src/utils/service-request"
import dayjs from "dayjs"

class PriceService {
    constructor() {
        this.request = new ServiceRequest()
        this.exportFile = new ExportFile()
    }

    async getPrices(startDate, endDate) {
        return await this.request.get(`${PRICE_PATH}?data_inicial=${startDate}&data_final=${endDate}`)
    }

    async getPricesv2(startDate, endDate) {
        return await this.request.get(`${PRICE_V2_PATH}?data_inicial=${startDate}&data_final=${endDate}`)
    }

    async getPricesPU() {
        return await this.request.get(`${PRICE_PU_PATH}`)
    }

    async getCustumersPricesLog(IDCliente, date) {
        if (!IDCliente) throw new Error("O parâmetro 'IDCliente' é obrigatório.")
        if (!date) throw new Error("O parâmetro 'date' é obrigatório.")

        return await this.request.get(`${CUSTOMERS_PRICE_LOG_PATH}?id_cliente=${IDCliente}&data_referencia=${date}`)
    }

    async loadLastDate() {
        return await this.request.get(`${PRICE_TABLE_LAST_DATE_PATH}`)
    }

    async loadTablePriceVariantion(data_referencia) {
        return await this.request.get(`${PRICE_TABLE_PRICE_VARIANTION_PATH}?data_referencia=${data_referencia}`)
    }

    async exportDataToCsv(date) {
        return this.getPricesv2(date, date, 5000, 0).then((response) => {
            const {body} = response
            const {data} = body

            const prices = data.map((item) => {
                const {
                    CETIP,
                    DataReferencia,
                    TaxaMTM,
                    PU_MTM,
                    DurationMTM,
                    DurationAno,
                    PUPAR,
                    PercentualPUPAR,
                    PU_Inf,
                    PU_Sup,
                    tipo_ativo,
                    devedor,
                    indicador,
                    taxa_accrual,
                    DataVencimento,
                    SpreadCredito,
                    IndiceLiquidez,
                    DataEventoProximo,
                    ValorProximoEvento,
                    // PremioRecompra,
                    // SpreadRecompra,
                    // PremioaPagar
                } = item

                return {
                    "DataReferencia": DataReferencia,
                    "CETIP": CETIP,
                    "Tipo": tipo_ativo,
                    "Vencimento": DataVencimento,
                    "Devedor": devedor,
                    "Indicador": indicador,
                    "TaxaACCRUAL": formatDecimalCaseReplaceComma(taxa_accrual),
                    "TaxaMTM": formatDecimalCaseReplaceComma(TaxaMTM),
                    "PU_MIN": formatDecimalCaseReplaceComma(PU_Inf),
                    "PU_MTM": formatDecimalCaseReplaceComma(PU_MTM),
                    "SpreadCredito": formatDecimalCaseReplaceComma(SpreadCredito),
                    "PU_MAX": formatDecimalCaseReplaceComma(PU_Sup),
                    "PUPAR": formatDecimalCaseReplaceComma(PUPAR),
                    "%PUPAR": formatDecimalCaseReplaceComma(PercentualPUPAR),
                    "DurationDU": formatDecimalCaseReplaceComma(DurationMTM),
                    "DurationAno": formatDecimalCaseReplaceComma(DurationAno),
                    "IndiceLiquidez": IndiceLiquidez,
                    "DataEventoProximo": DataEventoProximo,
                    "ValorProximoEvento": formatDecimalCaseReplaceComma(ValorProximoEvento),
                    // "PremioRecompra": formatDecimalCaseReplaceComma(PremioRecompra),
                    // "SpreadRecompra": formatDecimalCaseReplaceComma(SpreadRecompra),
                    // "PremioaPagar": formatDecimalCaseReplaceComma(PremioaPagar),
                }
            })

            this.exportFile.toCSV(prices, `precos-${date}`, ";")
        })
    }

    async exportDataVariationToCsv(data_referencia) {
        // aqui data_referencia já vem como "YYYY-MM-DD"
        return this.loadTablePriceVariantion(data_referencia, 5000, 0).then((response) => {
            const {body} = response
            const {data} = body

            const variantion = data.map((item) => ({
                "CETIP": item.CETIP,
                "DataReferencia": dayjs(item.DataReferencia).format(DATE_FORMAT_SHOW),
                "VNAPUPAR": formatStringToFloatDecimalCase(item.VNAPUPAR, 2, 6),
                "AtualizacaoMonetariaIncrementoPUPAR": formatStringToFloatDecimalCase(item.AtualizacaoMonetariaIncrementoPUPAR, 2, 6),
                "JurosAcruadosPUPAR": formatStringToFloatDecimalCase(item.JurosAcruadosPUPAR, 2, 6),
                "TaxaRiskFreeAnterior": formatStringToFloatDecimalCase(item.TaxaRiskFreeAnterior, 2, 6),
                "TaxaRiskFreeAtual": formatStringToFloatDecimalCase(item.TaxaRiskFreeAtual, 2, 6),
                "DeltaRiskFree": formatStringToFloatDecimalCase(item.DeltaRiskFree, 2, 6),
                "SpreadCreditoAnterior": formatStringToFloatDecimalCase(item.SpreadCreditoAnterior, 2, 6),
                "SpreadCreditoAtual": formatStringToFloatDecimalCase(item.SpreadCreditoAtual, 2, 6),
                "DeltaSpreadCredito": formatStringToFloatDecimalCase(item.DeltaSpreadCredito, 2, 6),
                "AjusteMTMDiario": formatStringToFloatDecimalCase(item.AjusteMTMDiario, 2, 6),
                "AmortizacaoOrdinariaPUPAR": formatStringToFloatDecimalCase(item.AmortizacaoOrdinariaPUPAR, 2, 6),
                "AmortizacaoExtraordinariaPUPAR": formatStringToFloatDecimalCase(item.AmortizacaoExtraordinariaPUPAR, 2, 6),
                "JurosPUPAR": formatStringToFloatDecimalCase(item.JurosPUPAR, 2, 6),
                "IncorporacaoJurosPUPAR": formatStringToFloatDecimalCase(item.IncorporacaoJurosPUPAR, 2, 6),
                "PremioPUPAR": formatStringToFloatDecimalCase(item.PremioPUPAR, 2, 6),
                "PagamentoPUPAR": formatStringToFloatDecimalCase(item.PagamentoPUPAR, 2, 6),
                "DataEventoProximo": (item.DataEventoProximo ? dayjs(item.DataEventoProximo).format(DATE_FORMAT_SHOW) : ""),
                "ClassificacaoProximoEvento": item.ClassificacaoProximoEvento,
                "ValorProximoEvento": formatStringToFloatDecimalCase(item.ValorProximoEvento, 2, 6),
                "PUPARAnterior": formatStringToFloatDecimalCase(item.PUPARAnterior, 2, 6),
                "PUPARAtual": formatStringToFloatDecimalCase(item.PUPARAtual, 2, 6),
                "DeltaPUPAR": formatStringToFloatDecimalCase(item.DeltaPUPAR, 2, 6),
                "VarPUPAR": formatStringToFloatDecimalCase(item.VarPUPAR, 2, 6),
                "PU_MTMAnterior": formatStringToFloatDecimalCase(item.PU_MTMAnterior, 2, 6),
                "PU_MTMAtual": formatStringToFloatDecimalCase(item.PU_MTMAtual, 2, 6),
                "DeltaPU_MTM": formatStringToFloatDecimalCase(item.DeltaPU_MTM, 2, 6),
                "VarPUMTM": formatStringToFloatDecimalCase(item.VarPUMTM, 2, 6),
                "JustificativaPUPAR": item.JustificativaPUPAR,
                "JustificativaPUMTM": item.JustificativaPUMTM,
            }))

            this.exportFile.toCSV(variantion, `variacao-diaria-${data_referencia}`, ";")
        })
    }

    async generatePriceData(startDate, endDate, cetipList) {
        let body = {
            "cetips": cetipList,
        }
        if (startDate) {
            body = {...body, "data_inicial": startDate.format(DATE_FORMAT)}
        }

        if (endDate) {
            body = {...body, "data_final": endDate.format(DATE_FORMAT)}
        }

        return await this.request.post(`${PRICE_PU_PATH}`, body)
    }

    generatePUChart(body) {
        const dataReferenciaArray = body.map(objeto => formatDate(objeto.DataReferencia))

        const puMTM = this.tranformData(body, "PU_MTM")

        return {
            PU_MTM: [{
                grupo: "PU MTM",
                items: puMTM.map(({CETIP, values}) => ({
                    item: CETIP,
                    values
                }))
            }],
            dateList: [...dataReferenciaArray]
        }
    }

    generatePUPARChart = (body) => {
        // reconstrói o array unificado
        const {PU_MTM, PUPAR, PercentualPUPAR} = body

        const unified = PU_MTM.map((item, index) => ({
            DataReferencia: item.DataReferencia,
            CETIP: item.CETIP,
            PU_MTM: item.PU_MTM,
            PUPAR: PUPAR[index].PUPAR,
            PercentualPUPAR: PercentualPUPAR[index].PercentualPUPAR,

            VNAPUPAR: PUPAR[index].VNAPUPAR,
            JurosIncrementoPUPAR: PUPAR[index].JurosIncrementoPUPAR,
            AtualizacaoMonetariaIncrementoPUPAR: PUPAR[index].AtualizacaoMonetariaIncrementoPUPAR,
            AmortizacaoOrdinariaPUPAR: PUPAR[index].AmortizacaoOrdinariaPUPAR,
            AmortizacaoExtraordinariaPUPAR: PUPAR[index].AmortizacaoExtraordinariaPUPAR,
            JurosPUPAR: PUPAR[index].JurosPUPAR,
            IncorporacaoJurosPUPAR: PUPAR[index].IncorporacaoJurosPUPAR,
            PagamentoPUPAR: PUPAR[index].PagamentoPUPAR,
            JustificativaPUPAR: PUPAR[index].JustificativaPUPAR,

            VNA_PUMTM: item.VNA_PUMTM,
            AmortizacaoOrdinariaPUMTM: item.AmortizacaoOrdinariaPUMTM,
            AmortizacaoExtraordinariaPUMTM: item.AmortizacaoExtraordinariaPUMTM,
            JurosPUMTM: item.JurosPUMTM,
            IncorporacaoJurosTotalPUMTM: item.IncorporacaoJurosTotalPUMTM,
            PagamentoPUMTM: item.PagamentoPUMTM,
            AjusteMTMDiario: item.AjusteMTMDiario,
            DeltaSpreadCredito: item.DeltaSpreadCredito,
            JustificativaPUMTM: item.JustificativaPUMTM
        }))

        const cetipList = new Set(unified.map(obj => obj.CETIP))
        let chartData = []

        cetipList.forEach(cetip => {

            const fromCetip = unified.filter(x => x.CETIP === cetip)

            const dataReferencia = fromCetip.map(item => formatDate(item.DataReferencia))
            const PU_MTM = fromCetip.map(item => parseFloat(item.PU_MTM).toFixed(4))
            const PUPAR = fromCetip.map(item => parseFloat(item.PUPAR).toFixed(4))
            const PERCENTUAL_PUPAR = fromCetip.map(item => parseFloat(item.PercentualPUPAR).toFixed(4))

            const VNAPUPAR = fromCetip.map(item => item.VNAPUPAR != null ? parseFloat(item.VNAPUPAR).toFixed(4) : null)
            const IncrementoDiarioJurosPUPAR = fromCetip.map(item => item.JurosIncrementoPUPAR != null ? parseFloat(item.JurosIncrementoPUPAR).toFixed(4) : null)
            const AtualizacaoMonetariaIncrementoPUPAR = fromCetip.map(item => item.AtualizacaoMonetariaIncrementoPUPAR != null ? parseFloat(item.AtualizacaoMonetariaIncrementoPUPAR).toFixed(4) : null)
            const AmortizacaoOrdinariaPUPAR = fromCetip.map(item => item.AmortizacaoOrdinariaPUPAR != null ? parseFloat(item.AmortizacaoOrdinariaPUPAR).toFixed(4) : null)
            const AmortizacaoExtraordinariaPUPAR = fromCetip.map(item => item.AmortizacaoExtraordinariaPUPAR != null ? parseFloat(item.AmortizacaoExtraordinariaPUPAR).toFixed(4) : null)
            const JurosPUPAR = fromCetip.map(item => item.JurosPUPAR != null ? parseFloat(item.JurosPUPAR).toFixed(4) : null)
            const IncorporacaoJurosPUPAR = fromCetip.map(item => item.IncorporacaoJurosPUPAR != null ? parseFloat(item.IncorporacaoJurosPUPAR).toFixed(4) : null)
            const PagamentoPUPAR = fromCetip.map(item => item.PagamentoPUPAR != null ? parseFloat(item.PagamentoPUPAR).toFixed(4) : null)
            const JustificativaPUPAR = fromCetip.map(item => item.JustificativaPUPAR ?? ' ')
            const tooltipExtraPupar = fromCetip.map((item, index) => {
                const pag = parseFloat(PagamentoPUPAR[index])
                const isPagamentoValido = pag !== 0 && !isNaN(pag)

                if (isPagamentoValido) {
                    return {
                        "VNA": VNAPUPAR[index],
                        "Incremento Atualização Monetária": AtualizacaoMonetariaIncrementoPUPAR[index],
                        "Incremento Diário de Juros": IncrementoDiarioJurosPUPAR[index],
                        "Amortização Ordinária": AmortizacaoOrdinariaPUPAR[index],
                        "Amortização Extraordinária": AmortizacaoExtraordinariaPUPAR[index],
                        "Cupom de Juros": JurosPUPAR[index],
                        "Incorporação de Juros": IncorporacaoJurosPUPAR[index],
                        "Pagamento": PagamentoPUPAR[index],
                        "Justificativa Variação": JustificativaPUPAR[index]
                    }
                }


                return {
                    "VNA": VNAPUPAR[index],
                    "Incremento Atualização Monetária": AtualizacaoMonetariaIncrementoPUPAR[index],
                    "Incremento Diário de Juros": IncrementoDiarioJurosPUPAR[index],
                    "Justificativa Variação": JustificativaPUPAR[index]
                }
            })

            const VNAPUMTM = fromCetip.map(item => item.VNA_PUMTM != null ? parseFloat(item.VNA_PUMTM).toFixed(4) : null)
            const AmortizacaoOrdinariaPUMTM = fromCetip.map(item => item.AmortizacaoOrdinariaPUMTM != null ? parseFloat(item.AmortizacaoOrdinariaPUMTM).toFixed(4) : null)
            const AmortizacaoExtraordinariaPUMTM = fromCetip.map(item => item.AmortizacaoExtraordinariaPUMTM != null ? parseFloat(item.AmortizacaoExtraordinariaPUMTM).toFixed(4) : null)
            const JurosPUMTM = fromCetip.map(item => item.JurosPUMTM != null ? parseFloat(item.JurosPUMTM).toFixed(4) : null)
            const IncorporacaoJurosPUMTM = fromCetip.map(item => item.IncorporacaoJurosTotalPUMTM != null ? parseFloat(item.IncorporacaoJurosTotalPUMTM).toFixed(4) : null)
            const PagamentoPUMTM = fromCetip.map(item => item.PagamentoPUMTM != null ? parseFloat(item.PagamentoPUMTM).toFixed(4) : null)
            const AjusteMTMDiario = fromCetip.map(item => item.AjusteMTMDiario != null ? parseFloat(item.AjusteMTMDiario).toFixed(4) : null)
            const DeltaSpreadCredito = fromCetip.map(item => item.DeltaSpreadCredito != null ? parseFloat(item.DeltaSpreadCredito).toFixed(4) : null)
            const JustificativaPUMTM = fromCetip.map(item => item.JustificativaPUMTM ?? ' ')
            const tooltipExtraPumtm = fromCetip.map((item, index) => {
                const pag = parseFloat(PagamentoPUMTM[index])
                const isPagamentoValido = pag !== 0 && !isNaN(pag)

                if (isPagamentoValido) {
                    return {
                        "VNA": VNAPUMTM[index],
                        "Amortização Ordinária": AmortizacaoOrdinariaPUMTM[index],
                        "Amortização Extraordinária": AmortizacaoExtraordinariaPUMTM[index],
                        "Cupom de Juros": JurosPUMTM[index],
                        "Incorporação de Juros": IncorporacaoJurosPUMTM[index],
                        "Pagamento": PagamentoPUMTM[index],
                        "Ajuste MTM Diário": AjusteMTMDiario[index],
                        "Delta Spread Crédito": DeltaSpreadCredito[index],
                        "Justificativa Variação": JustificativaPUMTM[index]
                    }
                }

                return {
                    "VNA": VNAPUMTM[index],
                    "Ajuste MTM Diário": AjusteMTMDiario[index],
                    "Delta Spread Crédito": DeltaSpreadCredito[index],
                    "Justificativa Variação": JustificativaPUMTM[index]
                }
            })
            chartData.push({
                grupo: cetip,
                items: [
                    {
                        item: "PU_MTM",
                        color: "#5DBB63",
                        id: null,
                        values: [...PU_MTM],
                        tooltipExtra: tooltipExtraPumtm
                    },
                    {
                        item: "PUPAR",
                        color: "#B388EB",
                        id: null,
                        values: [...PUPAR],
                        tooltipExtra: tooltipExtraPupar
                    },
                    {
                        item: "%PUPAR",
                        color: "#5A84FF",
                        id: "second-axis",
                        values: [...PERCENTUAL_PUPAR]
                    }
                ],
                dateList: [...dataReferencia]
            })
        })

        return chartData
    }


    tranformData(body, key) {
        const dadosAgrupados = {}

        body.forEach(dado => {
            const cetip = dado.CETIP
            const value = parseFloat(dado[key]).toFixed(5)

            dadosAgrupados[cetip] = dadosAgrupados[cetip] || {CETIP: cetip, values: []}

            dadosAgrupados[cetip].values.push({x: formatDate(dado.DataReferencia), y: value})
        })

        const gruposArray = Object.values(dadosAgrupados)

        return gruposArray
    }

    getLastDatesOcurrence(limit = 6) {
        return this.request.get(`${PRICE_LAST_DATE_PATH}?limit=${limit}`)
    }

    async getUpdateSpreads(date, limit = 25, offset = 0, filterQuery = '') {
        try {
            if (!date) {
                console.error('Data de referência é obrigatória')
                throw new Error('Data de referência é obrigatória')
            }

            if (date.indexOf('-') === -1) {
                console.error('Formato de data inválido')
                throw new Error('Formato de data inválido')
            }

            let url = `${PRICE_UPDATE_SPREADS_PATH}?date=${date}&limit=${limit}&offset=${offset}`

            if (filterQuery && filterQuery.trim() !== '') {
                url += `&${filterQuery}`
            }

            console.log('Chamando API com URL:', url)


            const response = await this.request.get(url)


            return response
        } catch (error) {
            console.error('Erro ao obter spreads:', error)
            throw error
        }
    }

    async paginate(endpoint) {
        return await this.request.getEndpoint(endpoint)
    }

    exportUpdateSpreads(date) {
        const url = `${PRICE_UPDATE_SPREADS_PATH}?date=${date}&export=true`

        return this.request.getBlob(url)
    }

    async getBondsPrices(data_referencia) {
        const response = await this.request.get(`${PRICE_BONDS_PATH}?data_referencia=${data_referencia}`)
        return response?.body?.data || []
    }

    async loadBondsLastDate() {
        const response = await this.request.get(`${PRICE_BONDS_LAST_DATE_PATH}`)
        return response?.body?.ultima_data || null
    }

    async exportBondsDataToCsv(data_referencia) {
        try {
            const bonds = await this.getBondsPrices(data_referencia)

            const formatted = bonds.map((item) => {
                return {
                    "Data Referência": item["Data Referência"],
                    "ISIN": item["ISIN"],
                    "Emissão": item["Emissão"],
                    "Vencimento": item["Vencimento"],
                    "Devedor": item["Devedor"],
                    "Moeda": item["Moeda"],
                    "Valor Nominal": formatDecimalCaseReplaceComma(item["Valor Nominal"]),
                    "Taxa MTM": formatDecimalCaseReplaceComma(item["Taxa MTM"]),
                    "PU MTM Limpo": formatDecimalCaseReplaceComma(item["PU MTM Limpo"]),
                    "PU MTM Sujo": formatDecimalCaseReplaceComma(item["PU MTM Sujo"]),
                    "%PUPAR Limpo": formatDecimalCaseReplaceComma(item["PercPUPAR Limpo"]),
                    "%PUPAR Sujo": formatDecimalCaseReplaceComma(item["PercPUPAR Sujo"]),
                    "Duration DC": formatDecimalCaseReplaceComma(item["Duration DC"]),
                    "Duration Ano": formatDecimalCaseReplaceComma(item["Duration Ano"]),
                    "Data Próximo Cupom": item["Data Próximo Cupom"],
                    "Cupom Accruado": formatDecimalCaseReplaceComma(item["Cupom Accruado"]),
                }
            })

            this.exportFile.toCSV(formatted, `bonds-${data_referencia}`, ";")
        } catch (err) {
            console.error("Erro ao exportar bonds:", err)
        }
    }

}

export default PriceService